<template>
	<footer class="footer">
		<div class="page-wrapper footer__wrapper">
			<section class="footer__section">
				<router-link to="/"><img :src="require('@/assets/' + $t('footer.footerLogo'))" alt="" class="footer__logo"/></router-link>
			</section>
			<section class="footer__section">
				<h1 class="footer__title">{{ $t('nav.footerTitle1') }}</h1>
				<ul class="footer__menu">
					<li class="footer__item">
						<router-link :to="$locale.toRouteLinkProp('crm')" class="menu__link">Prospects CRM</router-link>
					</li>
					<li class="footer__item">
						<router-link :to="$locale.toRouteLinkProp('mobile')" class="menu__link">{{ $t("mobileName") }}</router-link>
					</li>
				</ul>
			</section>
			<section class="footer__section">
				<h1 class="footer__title">{{ $t('nav.footerTitle2') }}</h1>
				<ul class="footer__menu">
					<li class="footer__item">
						<a href="https://prospectsinc.zendesk.com/hc" target="_blank" class="menu__link">{{ $t('nav.helpCenter') }}</a>
					</li>		
					<li class="footer__item">
						<router-link :to="$locale.toRouteLinkProp('contact')" class="menu__link">{{ $t('nav.contact') }}</router-link>
					</li>	
				</ul>
			</section>
			<section class="footer__section">
				<h1 class="footer__title">{{ $t('nav.footerTitle3') }}</h1>
				<ul class="footer__menu">
					<li class="footer__item">
						<router-link :to="$locale.toRouteLinkProp('about')" class="menu__link">{{ $t('nav.about') }}</router-link>
					</li>
					<li class="footer__item">
						<router-link :to="$locale.toRouteLinkProp('news')" class="menu__link">{{ $t("nav.news") }}</router-link>
					</li>
					<li class="footer__item">
						<a href="https://corelogic.wd5.myworkdayjobs.com/USCAN?locations=e0052c9790670137e67fb5f5cc074144" target="_blank" class="menu__link">{{ $t("nav.careers") }}</a>
					</li>
				</ul>
			</section>
		</div>
		<div class="page-wrapper">
			<ul class="footer__wrapper footer__wrapper--middle footer__menu footer__menu--bottom">
				<li class="footer__item footer__item--address"><img src="@/assets/address.svg" alt="" style="width: 15px"/>3 Place du Commerce, Suite 400, Montréal, QC, H3E 1H7</li>
				<li class="footer__item footer__item--phone"><img src="@/assets/phone.svg" alt="" style="width: 15px"/><a href="tel:1-888-765-9221" target="_blank">1-888-765-9221</a></li>
				<li class="footer__item footer__item--email"><img src="@/assets/email.svg" alt="" style="width: 15px"/><a href="mailto:support@prospects.com">support@prospects.com</a></li>
				<li class="footer__item footer__item--social"><a href="https://facebook.com/prospects" target="_blank"><img src="@/assets/facebook-c.svg" alt="Follow-us on Facebook!" style="width: 35px"/></a></li>
				<li class="footer__item footer__item--social"><a href="https://twitter.com/prspcts" target="_blank"><img src="@/assets/twitter-c.svg" alt="Follow-us on Twitter!" style="width: 35px"/></a></li>
				<li class="footer__item footer__item--social"><a href="https://www.linkedin.com/company/prospects-software-inc/" target="_blank"><img src="@/assets/linkedin-color.svg" alt="Follow-us on twitter!" style="width: 35px"/></a></li>
				<li class="footer__item footer__item--social"><a href="https://www.youtube.com/user/Prospectstube" target="_blank"><img src="@/assets/youtube-color.svg" alt="Follow-us on Youtube!" style="width: 35px"/></a></li>
				<li class="footer__item footer__item--social"><a href="https://www.instagram.com/prospects_software/" target="_blank"><img src="@/assets/instagram-color.svg" alt="Follow-us on Instagram!" style="width: 35px"/></a></li>
			</ul>
		</div>
		<div class="footer__bottom">
			<div class="page-wrapper">
				<ul class="footer__wrapper footer__wrapper--bottom footer__menu footer__menu--bottom">
					<li class="footer__item footer__item--policyLink"><router-link :to="$locale.toRouteLinkProp('privacy')">{{ $t("nav.footerPrivacy") }}</router-link></li>
					<li class="footer__item footer__item--copyright">&copy; {{ (new Date()).getFullYear() }} {{ $t("nav.footerCopyright") }}</li>
				</ul>
			</div>
		</div>
	</footer>
</template>

<script>
import Dropdown from '@/components/utils/Dropdown.vue'

export default {
	components: { Dropdown },

	mounted () {

	},

	data () {
		return {

		}
	},

	computed: {

	},

	methods: {

	}
}
</script>
<style scoped lang="scss">
	.footer { background: #3d3d3d; color: #666; position: relative; font-size: 1.5rem; }
	.footer__wrapper { padding: 40px 0; display: flex; flex-wrap: wrap; }
	.footer__wrapper--bottom { padding: 10px 0; }
	.footer__wrapper--middle { padding: 10px 0 70px; border-top: 2px solid #666; }
	.footer__section { flex:1; padding: 20px 40px; min-width: 175px; }
	.footer__section:first-child { padding-left: 0;}
	.footer__section:last-child { padding-right: 0;}
	.footer__logo { width: 255px; }
	.footer__title { color: white; font-size: 1.5rem; font-weight: 700; display: block; margin-bottom: 20px; text-transform: uppercase; border-bottom: 2px solid #666; padding-bottom: 10px; }
	.footer__menu { display: flex; flex-direction: column; list-style: none; color: white; }
	.footer__menu--bottom { font-size: 1.35rem; flex-direction: row; }
	.footer__menu--bottom .footer__item { margin-top: 0; padding-left: 10px; padding-right: 10px; }
	.footer__menu--bottom .footer__item:first-child { padding-left: 0;}
	.footer__menu--bottom .footer__item:last-child { padding-right: 0;}
	.footer__item { box-sizing: border-box; display: flex; align-items: center; }
	.footer__item { margin-top: 15px; color: #9a9a9a; justify-content: flex-start;}
	.footer__item a { color: #9a9a9a; }
	.footer__item:first-child { margin-top: 0; }
	.footer__item--email,.footer__item--terms { flex: 1; }
	.footer__bottom { background: #313131; padding: 30px 0; }
	.footer__item--address img, .footer__item--phone img, .footer__item--email img { margin-right: 10px; }
	.footer__item--policyLink { flex: 1;}
	.footer__item--copyright { align-self: flex-end;}
	@media (max-width: 900px) {
		.footer__wrapper { padding: 20px 0; text-align: center; }
		.footer__item { justify-content: center;}
		.footer__item--social { flex-basis: 50%; order: 3; padding-top: 20px; padding-bottom: 20px; margin-left: 0; text-align: right; }
		.footer__item--social:last-child{ text-align: left; }
		.footer__section:first-child, .footer__section:last-child {
			padding: 20px 40px;
		}
		.footer__menu--bottom {
			flex-wrap: wrap;

			.footer__item {
				margin-bottom: 15px;
				flex-basis: 100%;
			}
			.footer__item--social {
				padding: 0;
				flex-basis: 50%;
				justify-content: flex-end;
				padding: 0 5px;
			}
			.footer__item--social:last-child {
				justify-content: flex-start;
			}
		}
	}
	@media (max-width: 420px ) {
		.footer__menu--bottom .footer__item:first-child { align-items: flex-start;}
	}
</style>
